var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7502 20.6894L16.0861 15.0253C17.4471 13.3914 18.1258 11.2956 17.981 9.17393C17.8362 7.0523 16.8789 5.06818 15.3085 3.63432C13.738 2.20047 11.6752 1.42727 9.54918 1.47558C7.42316 1.5239 5.39761 2.39 3.89389 3.89371C2.39018 5.39742 1.52408 7.42298 1.47577 9.549C1.42746 11.675 2.20065 13.7378 3.63451 15.3083C5.06836 16.8788 7.05248 17.836 9.17412 17.9808C11.2958 18.1257 13.3915 17.447 15.0255 16.0859L20.6896 21.75L21.7502 20.6894ZM3.00018 9.74999C3.00018 8.41497 3.39606 7.10993 4.13776 5.9999C4.87946 4.88986 5.93366 4.0247 7.16706 3.51381C8.40047 3.00292 9.75766 2.86924 11.067 3.12969C12.3764 3.39014 13.5791 4.03302 14.5231 4.97702C15.4672 5.92103 16.11 7.12376 16.3705 8.43314C16.6309 9.74251 16.4973 11.0997 15.9864 12.3331C15.4755 13.5665 14.6103 14.6207 13.5003 15.3624C12.3902 16.1041 11.0852 16.5 9.75018 16.5C7.96058 16.498 6.24484 15.7862 4.9794 14.5208C3.71396 13.2553 3.00216 11.5396 3.00018 9.74999Z",
    fill: "#6D747D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch24);
export default __webpack_public_path__ + "static/media/Search24.ddada45d6fdb954dd29df818010f7544.svg";
export { ForwardRef as ReactComponent };